// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"860c377d","124":"f1f65cfc","241":"c8d19004","499":"b7886dfe","508":"a56357f7","601":"d7f33170","646":"a7e32ee5","680":"21c9a6a0","976":"217b9c4d"}[chunkId] + ".chunk.js";
};